import React from "react";
import PaperSection from "../../../display/PaperSection";
import { BookingContext } from "../context/BookingModalContext";
import PetSelector from "../../../form/PetSelector";
import ChipTitle from "../../../display/ChipTitle";
import { LocalHospital } from "@mui/icons-material";
import { TimeIcon } from "@mui/x-date-pickers";
import AppointmentTimePicker from "../../../../features/appointments/form/AppointmentTimePicker";
import {
  CREATE_APPOINTMENT,
  CREATE_APPOINTMENT_FOR_USER,
} from "../../../../enums/PermissionTitles";
import AppointmentTypePicker from "../../../../features/appointments/form/AppointmentTypePicker";
import { Grid, Stack } from "@mui/material";
import useUser from "../../../../hooks/useUser";
import SimpleAlert from "../../../display/SimpleAlert";
import { ToggleDrawerContext } from "../../../../contexts/ToggleDrawer";
import { useTranslation } from "react-i18next";
import ConfirmAndCancelButtons from "../../../buttons/ConfirmAndCancelButtons";
export default function SharedBookingModalForm() {
  const functions = React.useContext(BookingContext);
  const buttonPermissions = [CREATE_APPOINTMENT, CREATE_APPOINTMENT_FOR_USER];
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const { roles } = useUser();
  const { t } = useTranslation();
  return (
    <Grid container spacing={4}>
      <PaperSection>
        <PetSelector
          isNewUserSelected={functions.isNewUserSelected()}
          testId={"appointment.booking-form.pet-select"}
        />
      </PaperSection>
      <PaperSection>
        <ChipTitle title={"Service"} icon={<LocalHospital />} />
        <Stack spacing={2}>
          <AppointmentTypePicker testId={"appointment.booking-form"} />
        </Stack>
      </PaperSection>
      <PaperSection>
        <ChipTitle title={"Date&Time"} icon={<TimeIcon />} />
        <AppointmentTimePicker
          warningMessage={
            roles?.user ? "PickingATimeDoesntGaranteeApproval" : null
          }
          testId={"appointment.booking-form"}
        />
      </PaperSection>
      {roles?.user ? (
        <Grid item xs={12}>
          <SimpleAlert
            message={"WaitForClinicToApproveAppointment"}
            severity={"warning"}
            testId={"appointment.booking-form.pending-approval-alert"}
          />
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <ConfirmAndCancelButtons
          useCustomLoadingButtonOnConfirm={true}
          confirmButtonProps={{ disabled: functions.getLoading() }}
          confirmTitle="Book"
          cancelTitle="Cancel"
          permissions={[buttonPermissions]}
          onCancel={() => setIsOpen()}
          confirmButtonType="submit"
          testId={"appointment.booking-form"}
        />
      </Grid>
    </Grid>
  );
}
